<div class="client-modal">

  <!-- ------------------------------------------------------------------ header -->
  <div class="modal-header client-modal__header">
    <div class="client-modal__heading">
      <h5 class="client-modal__title">
        <span class="client-modal__lot" *ngIf="data.saleHorse?.lot">{{ data.saleHorse.lot }}</span>
        {{ data.saleHorse?.name }}
      </h5>
      <p class="client-modal__subtitle">
        Enter the name of the client you are viewing repository data for
      </p>
    </div>

    <button type="button"
            class="btn-close"
            aria-label="Close"
            (click)="activeModal.dismiss()"></button>
  </div>

  <!-- ------------------------------------------------------------------ body -->
  <div class="modal-body client-modal__body">

    <!-- Search -->
    <div class="input-group client-modal__search">
      <span class="input-group-text bg-white border-end-0">
        <i class="fas fa-search text-muted"></i>
      </span>
      <input #searchInput
             type="text"
             class="form-control border-start-0"
             [(ngModel)]="searchText"
             (input)="onSearchChange()"
             (keydown)="onSearchKeydown($event)"
             autocomplete="off"
             role="combobox"
             aria-expanded="true"
             aria-controls="client-name-list"
             aria-label="Search or create a client name"
             placeholder="Search or create a new client name" />
      <button *ngIf="searchText"
              type="button"
              class="btn btn-outline-secondary border-start-0"
              aria-label="Clear search"
              (click)="searchText = ''; onSearchChange()">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Current selection -->
    <div class="client-modal__selection" *ngIf="selectedViewer">
      <span class="client-modal__chip">
        <i class="fa fa-user me-1"></i>
        {{ selectedViewer.viewerName }}
        <button type="button"
                class="client-modal__chip-clear"
                aria-label="Clear selection"
                (click)="clearSelection()">
          <i class="fa fa-times"></i>
        </button>
      </span>
    </div>

    <!-- Loading -->
    <div class="client-modal__state" *ngIf="isLoading">
      <i class="fas fa-spinner fa-spin me-2"></i> Loading client names…
    </div>

    <!-- List -->
    <div class="client-modal__list" id="client-name-list" role="listbox" *ngIf="!isLoading">

      <!-- Create a new name -->
      <div class="client-modal__create" *ngIf="canCreateNew">
        <i class="fa fa-plus-circle me-2"></i>
        <span>
          Confirm to add <strong>{{ trimmedSearch }}</strong> as a new client name
        </span>
      </div>

      <!-- This clinic's own previously declared names (the only names ever listed) -->
      <ng-container *ngIf="visibleRows.length">
        <div class="client-modal__group-label">Used before by your clinic</div>
        <button *ngFor="let item of visibleRows; trackBy: trackByName"
                type="button"
                role="option"
                class="client-modal__item"
                [class.is-selected]="isSelected(item)"
                [class.is-active]="activeRow === item"
                [attr.aria-selected]="isSelected(item)"
                (click)="selectViewer(item)"
                (dblclick)="selectViewer(item); save()">
          <span class="client-modal__item-name">{{ item.viewerName }}</span>
        </button>
      </ng-container>

      <!-- Nothing matched -->
      <div class="client-modal__state" *ngIf="!visibleRows.length && !canCreateNew">
        <ng-container *ngIf="!listEnabled; else listOn">Type the client's name above.</ng-container>
        <ng-template #listOn>
          <ng-container *ngIf="allClientNames.length; else noNamesYet">No client names to show.</ng-container>
          <ng-template #noNamesYet>Your clinic has not declared any clients yet. Type a name above to add one.</ng-template>
        </ng-template>
      </div>
      <div class="client-modal__state" *ngIf="!visibleRows.length && canCreateNew">
        No existing client matches “{{ trimmedSearch }}”.
      </div>

      <!-- Say so when the cap bites, rather than silently truncating -->
      <div class="client-modal__more" *ngIf="hiddenCount > 0">
        {{ hiddenCount }} more not shown — keep typing to narrow the list.
      </div>
    </div>
  </div>

  <!-- ------------------------------------------------------------------ footer -->
  <div class="modal-footer client-modal__footer">
    <span class="client-modal__count" *ngIf="!isLoading">
      {{ totalMatchCount }} {{ totalMatchCount === 1 ? 'name' : 'names' }}
    </span>
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="activeModal.dismiss()">
      Cancel
    </button>
    <button type="button"
            class="btn btn-primary btn-sm"
            [disabled]="disableConfirm()"
            (click)="save()">
      <i class="fa fa-check me-1"></i>
      <ng-container *ngIf="!disableConfirm(); else plainConfirm">Confirm {{ confirmTargetName }}</ng-container>
      <ng-template #plainConfirm>Confirm</ng-template>
    </button>
  </div>
</div>
